import { Link } from 'react-router-dom';
import { categories } from '@/mocks/site';

const icons: Record<string, string> = {
  variety: 'ri-tv-2-line',
  influencer: 'ri-live-line',
  screen: 'ri-film-line',
  esports: 'ri-gamepad-line',
  marketing: 'ri-megaphone-line',
  music: 'ri-music-2-line',
};

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-12">
          <p className="text-xs tracking-[0.2em] text-secondary-600 font-medium mb-2 uppercase">
            Categories / 主题分类
          </p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            按主题找到你想看的内容
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((c) => (
            <Link
              key={c.id}
              to={`/library?cat=${c.id}`}
              className="group p-5 md:p-6 rounded-lg bg-background-50 border border-background-200 hover:border-secondary-400 transition-colors"
            >
              <div className="flex items-start justify-between mb-4">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${icons[c.id] ?? 'ri-price-tag-3-line'} text-xl`} />
                </span>
                <span className="text-xs text-foreground-500">{c.count} 个专题</span>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {c.name}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs text-primary-600">
                进入分类
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}